import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAllAavOrders, getAavOrderById } from '../../api/aavOrders';
import store from '../../store';
import { setNotifications } from '../slices/notifications';

export const getAavOrders = createAsyncThunk(
    'aavOrders/getAavOrders',
    async (queryParams: any, { rejectWithValue }) => {
        try {
            return await getAllAavOrders(queryParams);
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message, type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);

export const getAavOrder = createAsyncThunk(
    'aavOrders/getAavOrder',
    async (orderId: number | string, { rejectWithValue }) => {
        try {
            return await getAavOrderById(orderId);
        } catch (error: any) {
            store.dispatch(setNotifications({ text: error.message, type: 'error' }));
            return rejectWithValue(error.message);
        }
    }
);
